module.exports = __webpack_public_path__ + "img/taibaojiayuan.4aa1944e.png";